import { config } from '../../config';

const { nodeEnv } = config;

export const isNotProduction = () => nodeEnv !== 'production';
